"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

require("unfetch/polyfill");

var _apolloClient = require("apollo-client");

var _apolloLink = require("apollo-link");

var _apolloLinkRedux = require("apollo-link-redux");

var _apolloLinkRedux2 = _interopRequireDefault(_apolloLinkRedux);

var _apolloLinkHttp = require("apollo-link-http");

var _apolloCacheInmemory = require("apollo-cache-inmemory");

var _reduxStore = require("../stores/reduxStore");

var _reduxStore2 = _interopRequireDefault(_reduxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var link = _apolloLink.ApolloLink.from([new _apolloLinkRedux2.default(_reduxStore2.default), new _apolloLinkHttp.HttpLink({
	uri: window._nounConfig.graphqlEndpoint,
	credentials: "include"
})]);

var client = new _apolloClient.ApolloClient({
	link: link,
	cache: new _apolloCacheInmemory.InMemoryCache()
});

exports.default = client;